import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as firebase from "firebase";
import "./Header.css";

const logOut = () => {
  firebase
    .auth()
    .signOut()
    .then(() => {
      window.location = "/";
    });
};

const Header = props => (
  <div className="header">
    <header className="headerItems">
      <div>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
      </div>
      {props.loaded &&
        (props.currentUser ? (
          <div className="logout" role="button" tabIndex="0" onClick={logOut}>
            Logout
          </div>
        ) : (
          <Link to="/login">Login</Link>
        ))}
    </header>
  </div>
);

Header.propTypes = {
  currentUser: PropTypes.shape({
    email: PropTypes.string,
  }),
  loaded: PropTypes.bool,
};

Header.defaultProps = {
  currentUser: null,
  loaded: false,
};

const mapStateToProps = state => ({ ...state.auth });

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js